import { makeStyles } from "@mui/styles";
import { COLORS } from "../../../constant/colors";

const useStyles = makeStyles({
  headerSticky: {
    position: "fixed",
    zIndex: "1001",
    width: "100%",
    backgroundColor: COLORS.white,
  },
  socialBar: {
    width: "100%",
    borderBottom: "1px solid rgba(255, 255, 255, 0.1)",
    padding: "6px 0",
    background: `linear-gradient(135deg, ${COLORS.secondary} 0%,rgb(165, 136, 5) 100%)`,
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      background:
        "linear-gradient(90deg, transparent 0%, rgba(255, 255, 255, 0.1) 50%, transparent 100%)",
      animation: "shimmer 3s infinite",
    },
  },
  runningText: {
    whiteSpace: "nowrap",
    color: COLORS.white,
    fontWeight: 500,
    fontSize: 13,
    textShadow: "0 1px 2px rgba(0, 0, 0, 0.3)",
    letterSpacing: "0.5px",
  },
  popoverPaper: {
    borderRadius: "12px !important",
    overflow: "hidden !important",
  },
  popoverBody: {
    padding: "20px 25px",
    borderRadius: "12px",
    minWidth: "200px",
  },
  popoverList: {
    marginBottom: "8px !important",
    padding: "8px 0",
    borderBottom: "1px solid rgba(0, 0, 0, 0.05)",
    "&:last-child": {
      marginBottom: "0px !important",
      borderBottom: "none",
      paddingBottom: "0",
    },
    "&:first-child": {
      paddingTop: "0",
    },
  },
  popoverLink: {
    color: COLORS.textPrimary,
    cursor: "pointer",
    transition: "all 0.3s ease",
    fontSize: "14px",
    fontWeight: "500",
    display: "flex",
    alignItems: "center",
    textDecoration: "none",
    "&:hover": {
      color: COLORS.primary,
      textDecoration: "none",
    },
  },
  rightCol: {
    "@media (max-width: 767px)": {
      display: "none",
    },
  },
  socialBarRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    "@media (max-width:767px)": {
      flexDirection: "column",
      justifyContent: "flex-start",
    },
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  companyContact: {
    position: "relative",
    padding: "0 10px",
    "&:before": {
      content: '""',
      position: "absolute",
      background: "url(/images/divider-small.png) no-repeat center",
      backgroundSize: "contain",
      width: "7px",
      height: "29px",
      right: 0,
    },
    "&:last-child": {
      "&:hover a p": {
        color: COLORS.primary,
      },
      "&:before": {
        display: "none",
      },
    },
    "&:hover a p": {
      color: COLORS.secondary,
    },
  },
  webView: {
    "@media (max-width:480px)": {
      display: "none",
    },
  },
  mobileView: {
    display: "none",
    "@media (max-width:480px)": {
      display: "block",
    },
  },
  companyContactLink: {
    paddingRight: "10px",
    display: "flex",
    alignItems: "center",
  },
  divider: {
    marginRight: "10px",
  },
  icon: {
    marginRight: "5px",
  },
  contactText: {
    color: COLORS.lightGrey1,
    fontWeight: "500",
    fontSize: "14px",
    transition: "all 0.3s ease-in-out",
    fontFamily: "Poppins, sans-serif",
  },
  phone: {
    color: COLORS.secondary,
  },
  envelope: {
    color: COLORS.primary,
  },

  logoSecDivider: {
    marginLeft: 10,
  },
  logoSec: {
    padding: "10px 0px",
  },
  logo: {
    maxWidth: 130,
    minHeight: 90,
    transition: "transform 0.3s ease",
    "&:hover": {
      transform: "scale(1.05)",
    },
  },
  inputSec: {
    boxShadow: "0 4px 20px rgba(0, 0, 0, 0.1)",
    display: "flex",
    borderRadius: "25px",
    overflow: "hidden",
    border: "2px solid transparent",
    background:
      "linear-gradient(white, white) padding-box, linear-gradient(135deg, #a9253c, #ffce2a) border-box",
    "@media (max-width: 767px)": {
      display: "none",
    },
  },
  input: {
    minWidth: "200px",
    padding: "10px 16px",
    border: "none",
    fontSize: "13px",
    outline: "none",
    background: "transparent",
    "&::placeholder": {
      color: COLORS.textSecondary,
      fontSize: "13px",
    },
    "@media (max-width: 991px)": {
      minWidth: "160px",
    },
  },
  inputButton: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    outline: 0,
    padding: "10px 18px",
    border: "none",
    minWidth: "70px",
    color: COLORS.white,
    fontSize: "14px",
    fontWeight: "500",
    transition: "all 0.3s ease-in-out",
    cursor: "pointer",
    "&:hover": {
      background: `linear-gradient(135deg, ${COLORS.secondary} 0%, #f39c12 100%)`,
    },
  },
  headerButton: {
    position: "relative",
    padding: "0 15px",
    "&:last-child": {
      paddingRight: "0",
      "&::before": {
        display: "none",
      },
    },
    "&::before": {
      content: '""',
      position: "absolute",
      background: "url(/images/divider-big.png) no-repeat center",
      backgroundSize: "contain",
      width: "7px",
      height: "50px",
      right: 0,
      top: "50%",
      transform: "translateY(-50%)",
    },
  },
  buttonIcon: {
    color: COLORS.primary,
    fontSize: "17px",
    marginRight: "8px",
  },
  cartCount: {
    position: "absolute",
    color: COLORS.white,
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    top: "-8px",
    right: "-8px",
    borderRadius: "50%",
    width: "20px",
    height: "20px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "11px",
    fontWeight: "600",
    boxShadow: "0 2px 8px rgba(169, 37, 60, 0.3)",
    border: "2px solid white",
  },
  link: {
    display: "flex",
    alignItems: "center",
    flexDirection: "row",
    color: COLORS.textPrimary,
    fontSize: "14px",
    fontWeight: "500",
    textDecoration: "none",
    transition: "all 0.3s ease-in-out",
    padding: "8px 12px",
    borderRadius: "8px",
    "&:hover": {
      textDecoration: "none !important",
      color: COLORS.primary,
      background: "rgba(169, 37, 60, 0.05)",
      transform: "translateY(-1px)",
    },
  },
  menuBar: {
    background: `linear-gradient(135deg, ${COLORS.primary} 0%, #c0392b 100%)`,
    minHeight: 50,
    boxShadow: "0 2px 10px rgba(169, 37, 60, 0.2)",
    position: "relative",
    "&::before": {
      content: '""',
      position: "absolute",
      top: 0,
      left: 0,
      right: 0,
      height: "2px",
      background: `linear-gradient(90deg, ${COLORS.secondary} 0%, #f39c12 50%, ${COLORS.secondary} 100%)`,
    },
  },
  menuUl: {
    display: "flex",
    justifyContent: "center",
    marginBottom: "0px",
    flexWrap: "wrap",
    padding: "0 20px",
  },
  menuLi: {
    position: "relative",
    "&:hover": {
      "& $menuLink": {
        background: "rgba(255, 255, 255, 0.1)",
        transform: "translateY(-2px)",
      },
    },
  },
  menuLink: {
    color: COLORS.black,
    fontWeight: "500",
    fontSize: "15px",
    transition: "all 0.3s ease-in-out",
    padding: "12px 10px",
    borderRadius: "8px",
    margin: "0 5px",
    "&:hover": {
      color: COLORS.secondary,
      textDecoration: "none",
    },
    "@media (max-width: 991px)": {
      fontSize: "14px",
      padding: "12px 15px",
    },
  },
  dropdownMenuLink: {
    color: COLORS.black,
    fontWeight: "normal",
    fontSize: "14px",
    transition: "all 0.3s ease-in-out",
    padding: "5px 0px",
    "&:hover": {
      color: COLORS.secondary,
      textDecoration: "none",
    },
  },
  dropdownContent: {
    position: "absolute",
    backgroundColor: "#fff",
    zIndex: 9999,
    left: 0,
    padding: "15px",
    opacity: 0,
    visibility: "hidden",
    maxWidth: 200,
    minWidth: 200,
    width: "100%",
    transform: "translateY(30px)",
    transition: "transform .35s linear",
    boxShadow: "0px 2px 10px rgba(0, 0, 0, 0.3)",
    pointerEvents: "none",
  },
  block: {
    display: "flex",
    flexWrap: "wrap",
  },
  categoriesBox: {
    display: "flex",
    alignItems: "center",
    flexDirection: "column",
    paddingRight: "20px",
    maxWidth: "160px",
    textAlign: "center",
    "&:hover img": {
      color: "#eaaa64",
      border: "1px solid #eaaa64",
      transition: "all .3s ease-in-out",
    },
  },
  boxImage: {
    border: "1px solid #e5e5e5",
    transition: "all .3s ease-in-out",
  },
  root: {
    borderBottom: "1px solid #e5e5e5",
    "&:last-child": {
      borderBottom: "none",
    },
  },
  nested: {
    paddingLeft: 10,
  },
  subCategoryImage: {
    width: 60,
    height: 60,
    marginRight: 10,
    border: "1px solid #e5e5e5",
  },
  productName: {
    marginBottom: 0,
    fontSize: 13,
    lineHeight: "15px",
    marginTop: 5,
  },
  productPrice: {
    color: "#eaaa64",
    fontSize: 13,
    lineHeight: "15px",
    marginTop: 5,
  },
  categoryName: {
    fontSize: 13,
    lineHeight: "18px",
    marginTop: 5,
  },
  "@keyframes shimmer": {
    "0%": {
      transform: "translateX(-100%)",
    },
    "100%": {
      transform: "translateX(100%)",
    },
  },
});

export default useStyles;
